import React from "react";
import DOMPurify from "dompurify";

interface HtmlContentProps {
  htmlString: string;
}

const HtmlContent: React.FC<HtmlContentProps> = ({ htmlString }) => {
  // Sanitize the HTML string
  const sanitizedHtml = DOMPurify.sanitize(htmlString);

  return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default HtmlContent;
